// @flow
import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import {Divider, Typography} from '@material-ui/core';
import CustomButton from '../../../../elements/CustomButton/CustomButton';
import makeStyles from '@material-ui/core/styles/makeStyles';

import CustomModal from '../../../../elements/CustomModal/CustomModal';
import type {
  Order,
  // DeliveryMethodName,
  ShippingMethod,
  PickupMethod,
  Country,
} from '../../../../entities';
import type {CheckoutRequest} from '../../../manual-order/api';
import {colors} from '../../../../assets/styles/colors';
import {useForm, FormProvider} from 'react-hook-form';

import type {RootState} from '../../../index';
import type {Dispatch} from 'redux';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {actions as ManualOrderActions} from '../../../manual-order/duck';
import {useCallback} from 'react';
// import ShippingForm from '../../../manual-order/components/ShippingForm';

import DeliveryForm from '../../../manual-order/components/delivery-form';
import {DELIVERY_FORM_FIELDS} from '../../../manual-order/components/delivery-form/constant';
// import {ORDER_TAX_INVOICE_FORM_FIELDS} from '../../../manual-order/components/TaxInvoiceInformationForm';
// import {useAdditionalInformationContext} from '../../../configure/sales-process/context/hooks';
// import {useAdditionalInformation} from '../../../configure/sales-process/hooks';

// import {
//   formatAddressString,
//   getAddressFromShippingDetail,
// } from '../../../map/utils';
import {useStoreCountry} from '../../../country/utils';
import {useEnabledLogisticShipping} from '../../../configure/logistics/logistics/utils';

export default connect(
  (state: RootState) => ({
    editOrderSuccess: state.manualOrder.editOrderSuccess,
    editOrderError: state.manualOrder.editOrderError,
    shippingMethod: state.logisticsConfig.shippingMethod,
    pickupMethod: state.logisticsConfig.pickupMethod,
    country: state.country.country,
  }),
  (dispatch: Dispatch<any>) =>
    bindActionCreators(
      {
        ...ManualOrderActions,
      },
      dispatch
    )
)(EditDeliveryInfoModal);

type Props = {
  isSaving?: boolean,
  open: boolean,
  handleClose: () => void,
  order: Order,
  shippingMethod?: ShippingMethod,
  pickupMethod?: PickupMethod,
  country?: Country,
  editOrder: ({checkoutRequest: CheckoutRequest}) => void,
};

// type TempOrderInfo = {
//   address1?: string,
//   address2?: string,
//   admin1Name?: string,
//   admin2Name?: string,
//   admin3Name?: string,
//   admin1Id?: string | number,
//   admin2Id?: string | number,
//   admin3Id?: string | number,
// };

const useStyles = makeStyles(theme => ({
  root: {
    // padding: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    width: 340,
  },
  title: {
    alignSelf: 'center',
    fontSize: '1.25rem',
    fontWeight: 600,
    marginTop: theme.spacing(2),
  },
  divider: {
    background: colors.grey200,
    width: '100%',
    margin: theme.spacing(2, 0),
  },
  textField: {
    '&:not(:last-child)': {
      marginBottom: theme.spacing(2),
    },
  },
  button: {
    height: 40,
    fontSize: '1rem',
    alignSelf: 'stretch',
    margin: theme.spacing(2, 0),
    width: '100%',
  },
  form: {
    width: '100%',
  },
}));

function EditDeliveryInfoModal(props: Props) {
  const {
    isSaving,
    open,
    handleClose,
    order,
    shippingMethod,
    // pickupMethod,
    // country,
    editOrder,
  } = props;
  const classes = useStyles();
  const methods = useForm();
  const storeCountry = useStoreCountry();

  const {getDeliveryMethods} = useEnabledLogisticShipping();

  useEffect(() => {
    getDeliveryMethods();
  }, [getDeliveryMethods]);

  const deliveryMethod = methods.watch(DELIVERY_FORM_FIELDS.DELIVERY_METHOD);

  const handleCloseModal = useCallback(() => {
    if (!isSaving) {
      handleClose();
    }
  }, [handleClose, isSaving]);

  const handleAmountReceivedSubmit = data => {
    const address1 = data[DELIVERY_FORM_FIELDS.ADDRESS_1];
    const address2 = data[DELIVERY_FORM_FIELDS.ADDRESS_2];
    const zipCode = data[DELIVERY_FORM_FIELDS.ZIP_CODE];
    const country =
      data[DELIVERY_FORM_FIELDS.COUNTRY]?.code || storeCountry.code;
    const admin1 = data[DELIVERY_FORM_FIELDS.ADMIN1]?.adminId;
    const admin2 = data[DELIVERY_FORM_FIELDS.ADMIN2]?.adminId;
    const admin3 = data[DELIVERY_FORM_FIELDS.ADMIN3]?.adminId;
    const shippingRateId = data[DELIVERY_FORM_FIELDS.SHIPPING_RATE_ID];
    const pickupMethod = data[DELIVERY_FORM_FIELDS.PICKUP_METHOD];
    const deliveryMethod = data[DELIVERY_FORM_FIELDS.DELIVERY_METHOD];
    const manualDeliveryCost = data[DELIVERY_FORM_FIELDS.MANUAL_DELIVERY_COST];

    const isShipping = deliveryMethod === 'SHIPPING';

    const pickUpRateId = pickupMethod?.shippingRates[0]?.id;

    const checkoutRequest = {
      deliveryData: {
        // shippingRateId: order.id,
        deliveryMethod,
        manualDeliveryCost,
        shippingRateId: isShipping ? shippingRateId : pickUpRateId,
        shippingMethodType:
          // $FlowFixMe
          isShipping && shippingMethod.storeShippingMethodType !== 'MANUAL'
            ? shippingMethod.storeShippingMethodType
            : undefined,
      },
    };

    if (isShipping) {
      // $FlowFixMe
      checkoutRequest.deliveryData.shippingAddress = {
        address1,
        address2: address2 ? address2 : undefined,
        admin1: Number(admin1),
        admin2: Number(admin2),
        admin3: admin3 ? Number(admin3) : undefined,
        country: country,
        zipCode: zipCode ? zipCode : undefined,
      };
    }

    editOrder({checkoutRequest: {id: order.id, request: checkoutRequest}});
  };

  return (
    <CustomModal open={open} handleCloseModal={handleCloseModal}>
      <div className={classes.root}>
        <Typography className={classes.title} align="center">
          Editar dirección de envío
        </Typography>
        <Divider className={classes.divider} />
        <div className={classes.form}>
          {order && (
            <FormProvider {...methods}>
              <DeliveryForm
                defaultDeliveryAddress={order.shippingAddress}
                defaultDeliveryMethod={order.deliveryMethod}
                defaultCreationType={order.orderCreationType}
                isEditing
              />
            </FormProvider>
          )}
          <CustomButton
            className={classes.button}
            variant="contained"
            onClick={methods.handleSubmit(handleAmountReceivedSubmit)}
            disabled={!deliveryMethod || isSaving}
          >
            Guardar cambios
          </CustomButton>
        </div>
      </div>
    </CustomModal>
  );
}

EditDeliveryInfoModal.propTypes = {
  isSaving: PropTypes.bool,
  open: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  order: PropTypes.object.isRequired,
  shippingMethod: PropTypes.object,
  pickupMethod: PropTypes.object,
  country: PropTypes.object,
  editOrder: PropTypes.func,
};
